import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SystemIndexComponent } from './crud-index/crud-index.component';
import { SystemCESComponent } from './crud-ces/crud-ces.component';

const routes: Routes = [
  {
    path: '',
    component: SystemIndexComponent,
  },
  {
    path: 'create',
    component: SystemCESComponent,
    data: [{ action: 'create' }],
  },
  {
    path: 'view/:id',
    component: SystemCESComponent,
    data: [{ action: 'view' }],
  },
  {
    path: 'edit/:id',
    component: SystemCESComponent,
    data: [{ action: 'edit' }],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SystemsRoutingModule {}
